import SmartSuggestionsList from "PFApp/search/smart_suggestions/smart_suggestions_list";
import SmartSuggestionsShell from "PFApp/search/smart_suggestions/smart_suggestions_shell";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const SkillsPageSuggestions = ({ skills, setSkills, currentProfile }) => {
  const { t } = useTranslation("onboarding");

  const [page, setPage] = useState(1);
  const profileSkills = currentProfile.suggestions.skills;
  const items = profileSkills ? profileSkills.filter(({ id }) => !skills.find((item) => item.id === id)) : [];

  return (
    <SmartSuggestionsShell empty={!items || items.length === 0} style={{ left: 20, bottom: 20 }}>
      <p>{t("identifiedRelatedSkillFromCV")}</p>

      <SmartSuggestionsList
        items={items}
        onAdd={(item) => setSkills((skills) => [...skills, { ...item, text: item.text || item.value, item }])}
        cycle={() => setPage(page + 1)}
        cycleOffset={page - 1}
        usedOn="onboarding"
        userId={currentProfile.id}
      />
    </SmartSuggestionsShell>
  );
};

SkillsPageSuggestions.propTypes = {
  skills: PropTypes.array,
  setSkills: PropTypes.func,
  currentProfile: PropTypes.object
};

export default SkillsPageSuggestions;
